import { combineReducers } from 'redux';
import TutorialReducer from '../Reducers/TutorialReducer';
import CartReducer from '../Reducers/CartReducer';
import CommonReducer from '../Reducers/CommonReducer';
import postReducer from '../Reducers/ProductNameReducer';
import QuoteReducer from '../Reducers/QuoteReducer';
import UserReducer from '../Reducers/UserReducer';
import CRMReducer from '../Reducers/CRMReducer';
import CompareQuotesReducer from '../Reducers/CompareQuotesReducer';

export default combineReducers({
    TutorialReducer,
    CartReducer,
    CommonReducer,
    QuoteReducer,
    UserReducer,
    CRMReducer,
    postReducer,
    CompareQuotesReducer
});